"use client";

import { useState, useEffect, useContext, useMemo } from "react";
import { useHistory } from "react-router-dom";
import CartContext from "../../../context/CartContext/CartContext";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Button,
  Badge,
  List,
  ListItem,
  ListItemText,
  TextField,
  InputAdornment,
  Avatar,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Chip,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
  Switch,
  FormControlLabel,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Alert,
  Snackbar,
  RadioGroup,
  Radio,
  FormLabel,
} from "@mui/material";
import {
  ShoppingCart,
  Receipt,
  ClearAll,
  Search,
  PersonAdd,
  Close,
  Person,
  Add,
  Edit,
  Check,
  Cancel,
  AttachMoney,
  Warning,
  PaymentOutlined,
  ArrowForward,
  Category,
  People,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import {
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonText,
  IonToolbar,
} from "@ionic/react";
import { removeOutline, add as addIcon } from "ionicons/icons";
import {
  getBarInventoryByBranch,
  getCategories,
} from "../../../api/products/product";
import { createCustomerOrder } from "../../../api/orders/orders";
import { formatCurrencyN } from "../../../common/utils_t";
import {
  createCustomer,
  getCustomerGrades,
  searchCustomers,
} from "../../../api/customers/customers";
import axios from "axios";
import { baseUrl, config, requestID } from "../../../common/utils";

const StyledProductCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  cursor: "pointer",
  transition: "transform 0.2s",
  "&:hover": {
    transform: "scale(1.02)",
    boxShadow: theme.shadows[4],
  },
}));

// Helper function to generate request ID
 
// API function to fetch receptionists from backend
const getStaffList_saleapp = async () => {
  const data = {
    requestID: requestID(),
  };
  try {
    const response = await axios.post(
      baseUrl() + "businesss/getAllStaffs_saleapp_byBranch",
      data,
      config
    );
    console.log("staff response recep", response);
    return response.data;
  } catch (error) {
    console.error("Error fetching staff:", error);
    throw error;
  }
};

 

 

const SalesPOSPage = () => {
  const history = useHistory();
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const {
    items,
    totalAmount,
    addItem,
    removeItem,
    clearCart,
    updateItemPrice,
  } = useContext(CartContext);
  
  // Receptionist states
  const [receptionists, setReceptionists] = useState([]);
  const [selectedReceptionist, setSelectedReceptionist] = useState(null);
  const [loadingReceptionists, setLoadingReceptionists] = useState(false);
  
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedCustomers, setSearchedCustomers] = useState([]);
  const [customerGrades, setCustomerGrades] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showCustomerDialog, setShowCustomerDialog] = useState(false);
  const [customerSearchQuery, setCustomerSearchQuery] = useState("");
  const [newCustomer, setNewCustomer] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    phone: "",
    email: "",
    grade: "A",
  });
  const [loading, setLoading] = useState({
    customers: false,
    grades: false,
    products: false,
  });
  const [processingOrder, setProcessingOrder] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [useGradePricing, setUseGradePricing] = useState(false);
  const [showPriceDialog, setShowPriceDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [customPrice, setCustomPrice] = useState("");
  const [editingItemId, setEditingItemId] = useState(null);
  const [editPrice, setEditPrice] = useState("");
  const [priceError, setPriceError] = useState("");
  const [editPriceError, setEditPriceError] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [totalAmountInput, setTotalAmountInput] = useState("");

  // Flex printing calculation states
  const [length, setLength] = useState("");
  const [breadth, setBreadth] = useState("");
  const [specialPrice, setSpecialPrice] = useState("");

  // CTP calculation states
  const [colorSeparation, setColorSeparation] = useState("spot"); // "spot" or "full"
  const [ctpBasePrice, setCtpBasePrice] = useState("");

  const [showProcessPaymentDialog, setShowProcessPaymentDialog] = useState(false);
  const [lastOrderCustomer, setLastOrderCustomer] = useState(null);

  // NEW STATE: Selected category for the transaction
  const [selectedTransactionCategory, setSelectedTransactionCategory] = useState("");

  // Calculate custom price when flex printing dimensions change
  useEffect(() => {
    if (selectedProduct && isFlexPrintingCategory(selectedProduct.category)) {
      const l = parseFloat(length) || 0;
      const b = parseFloat(breadth) || 0;
      const sp = parseFloat(specialPrice) || parseFloat(selectedProduct?.sellingPrice) || 0;
      const calculatedPrice = l * b * sp;
      
      if (!isNaN(calculatedPrice) && calculatedPrice > 0) {
        setCustomPrice(calculatedPrice.toFixed(2));
        
        // Also update total amount
        const qty = parseFloat(quantity) || 1;
        const newTotalAmount = calculatedPrice * qty;
        setTotalAmountInput(newTotalAmount.toFixed(2));
      }
    }
  }, [length, breadth, specialPrice, selectedProduct, quantity]);

  // Calculate CTP price when color separation or quantity changes
  useEffect(() => {
    if (selectedProduct && isCTPCategory(selectedProduct.category)) {
      const basePrice = parseFloat(ctpBasePrice) || parseFloat(selectedProduct?.price) || 0;
      let calculatedPrice = 0;
      
      if (colorSeparation === "full") {
        // Full color: (basePrice - 50) * 4
        calculatedPrice = (basePrice - 50) * 4;
      } else {
        // Spot color: basePrice * 1
        calculatedPrice = basePrice * 1;
      }
      
      if (!isNaN(calculatedPrice) && calculatedPrice > 0) {
        setCustomPrice(calculatedPrice.toFixed(2));
        
        // Also update total amount
        const qty = parseFloat(quantity) || 1;
        const newTotalAmount = calculatedPrice * qty;
        setTotalAmountInput(newTotalAmount.toFixed(2));
      }
    }
  }, [colorSeparation, ctpBasePrice, selectedProduct, quantity]);

  // Helper function to check if product is flex printing category
  const isFlexPrintingCategory = (category) => {
    return category === "FLEXPRINTING" || 
           category === "BANNER_PRINTING" || 
           category === "SAV" || 
           category === "TRANSPERNAT STICKERS" || 
           category === "SUBLIMATION PRINTING" || 
           category === "MESH" ;
  };

  // Helper function to check if product is CTP category
  const isCTPCategory = (category) => {
    return category === "CTP" || 
           category?.toUpperCase()?.includes("CTP");
  };

  // Helper function to get available quantity for a product
  const getAvailableQuantity = (productId) => {
    const product = allProducts.find(p => p.product_id === productId);
    return product ? product.qty : 0;
  };

  // Helper function to get current cart quantity for a product
  const getCartQuantity = (productId) => {
    const cartItem = items.find(item => item.product_id === productId);
    return cartItem ? cartItem.quantity : 0;
  };

  // Helper function to get remaining available quantity for a product
  const getRemainingQuantity = (productId) => {
    const availableQty = getAvailableQuantity(productId);
    const cartQty = getCartQuantity(productId);
    return Math.max(0, availableQty - cartQty);
  };

  // Helper function to get full name
  const getFullName = (person) => {
    if (!person) return "";
    const firstName = person.firstName || person.firstname || "";
    const middleName = person.middleName || person.middlename || "";
    const lastName = person.lastName || person.lastname || "";
        const emailName = person.email || person.email || "";

    return `${firstName} ${middleName ? middleName + ' ' : ''}${lastName} - ${emailName}`.trim();
  };

  const filteredProducts = useMemo(() => {
    if (!Array.isArray(products)) {
      return [];
    }
    return products.filter((product) => {
      const matchesCategory = selectedCategory
        ? String(product.productCategory) === String(selectedCategory)
        : true;
      const matchesSearch = product.name
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      return matchesCategory && matchesSearch;
    });
  }, [products, selectedCategory, searchQuery]);

  const validatePrice = (price, minSalePrice) => {
    const numPrice = Number.parseFloat(price);
    const numMinPrice = Number.parseFloat(minSalePrice);
    if (isNaN(numPrice) || numPrice <= 0) {
      return "Please enter a valid price";
    }
    if (numPrice < numMinPrice) {
      return `Price cannot be less than minimum sale price of ${formatCurrencyN(
        numMinPrice
      )}`;
    }
    return "";
  };
  const [selectProduct, setSelectProduct] = useState(null);

  const handleClosePriceDialog = () => {
    setShowPriceDialog(false);
    setSelectedProduct(null);
    setCustomPrice("");
    setPriceError("");
    setQuantity(1);
    setTotalAmountInput("");
    setSelectedGrade("");
    setLength("");
    setBreadth("");
    setSpecialPrice("");
    setColorSeparation("spot");
    setCtpBasePrice("");
  };

  const handleAddToCart = (product) => {
    setSelectProduct(product);
    if (useGradePricing && selectedCustomer) {
      // Check available quantity for grade pricing
      const availableQty = getRemainingQuantity(product.product_id);
      if (availableQty <= 0) {
        setSnackbarMessage(`Cannot add ${product.name}. Only ${getAvailableQuantity(product.product_id)} available in stock.`);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }
      
      addItem({
        id: product.product_id,
        product_name: product.name,
        quantity: 1,
        price: product.price - selectedCustomer?.grade_value * product.price,
        product_id: product.product_id,
        image: product.img_src,
        base_price: product.price,
        min_sale_price: product.minSalePrice,
        available_qty: product.qty, // Store available quantity
        transaction_category: selectedTransactionCategory, // Add selected category to item
      });
    } else {
      // Check available quantity for custom pricing
      const availableQty = getRemainingQuantity(product.product_id);
      if (availableQty <= 0) {
        setSnackbarMessage(`Cannot add ${product.name}. Only ${getAvailableQuantity(product.product_id)} available in stock.`);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }

      setSelectedProduct(product);
      setQuantity(1);
      
      // Initialize values based on product category
      if (isFlexPrintingCategory(product.category)) {
        // For flex printing, initialize with default values
        setLength("1");
        setBreadth("1");
        setSpecialPrice(product.sellingPrice || product.price || "0");
        // customPrice will be auto-calculated by useEffect
      } else if (isCTPCategory(product.category)) {
        // For CTP products, initialize with base price
        const priceStr = product.price.toString();
        setCtpBasePrice(priceStr);
        setColorSeparation("spot");
        // customPrice will be auto-calculated by useEffect
      } else {
        // For regular products
        const priceStr = product.price.toString();
        setCustomPrice(priceStr);
        setTotalAmountInput(priceStr);
      }
      
      setPriceError("");
      setShowPriceDialog(true);
    }
  };

  const handleQuantityChange = (value) => {
    const availableQty = getRemainingQuantity(selectedProduct?.product_id);
    const newQuantity = Math.max(1, Number.parseInt(value, 10) || 1);
    
    // Don't allow quantity more than available
    if (newQuantity > availableQty) {
      setSnackbarMessage(`Cannot add more than ${availableQty} items. Only ${availableQty} available in stock.`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      setQuantity(availableQty);
      return;
    }
    
    setQuantity(newQuantity);

    // If it's a special category product, the total will be auto-calculated
    // For regular products, calculate manually
    if (!isFlexPrintingCategory(selectedProduct?.category) && !isCTPCategory(selectedProduct?.category)) {
      const price = Number.parseFloat(customPrice);
      if (!isNaN(price)) {
        setTotalAmountInput((price * newQuantity).toFixed(2));
      }
    }
  };

  const handleCustomPriceChange = (value) => {
    setCustomPrice(value);
    if (selectedProduct) {
      const error = validatePrice(value, selectedProduct.minSalePrice);
      setPriceError(error);
    }
    
    // Only calculate total for non-special category products
    if (!isFlexPrintingCategory(selectedProduct?.category) && !isCTPCategory(selectedProduct?.category)) {
      const price = Number.parseFloat(value);
      if (!isNaN(price)) {
        setTotalAmountInput((price * quantity).toFixed(2));
      }
    }
  };

  const handleTotalAmountChange = (value) => {
    setTotalAmountInput(value);
    const total = Number.parseFloat(value);
    if (!isNaN(total) && quantity > 0) {
      const newPrice = total / quantity;
      setCustomPrice(newPrice.toFixed(5));
      if (selectedProduct) {
        const error = validatePrice(
          newPrice.toFixed(5),
          selectedProduct.minSalePrice
        );
        setPriceError(error);
      }
    }
  };

  const handleAddWithCustomPrice = () => {
    if (selectedProduct && customPrice && !priceError) {
      const error = validatePrice(customPrice, selectedProduct.minSalePrice);
      if (error) {
        setPriceError(error);
        return;
      }
      
      // Check available quantity
      const availableQty = getRemainingQuantity(selectedProduct.product_id);
      if (quantity > availableQty) {
        setSnackbarMessage(`Cannot add ${quantity} items. Only ${availableQty} available in stock.`);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }
      
      const itemToAdd = {
        id: selectedProduct.product_id,
        product_name: selectedProduct.name,
        quantity: quantity,
        price: Number.parseFloat(customPrice),
        product_id: selectedProduct.product_id,
        image: selectedProduct.img_src,
        base_price: selectedProduct.price,
        min_sale_price: selectedProduct.minSalePrice,
        custom_price: true,
        category: selectedProduct.category,
        available_qty: selectedProduct.qty, // Store available quantity
        transaction_category: selectedTransactionCategory, // Add selected category to item
      };

      // Add flex printing dimensions if applicable
      if (isFlexPrintingCategory(selectedProduct.category)) {
        itemToAdd.length = length;
        itemToAdd.breadth = breadth;
        itemToAdd.special_price = specialPrice;
        itemToAdd.calculation_note = `${length} × ${breadth} × ${specialPrice} = ${customPrice}`;
      }
      
      // Add CTP details if applicable
      if (isCTPCategory(selectedProduct.category)) {
        itemToAdd.color_separation = colorSeparation;
        itemToAdd.base_price_used = ctpBasePrice;
        
        // Create the calculation string
        const basePriceNum = parseFloat(ctpBasePrice) || parseFloat(selectedProduct.price);
        const calculationStr = colorSeparation === "full" 
          ? `(${basePriceNum.toFixed(2)} - 50) × 4 = ${customPrice}`
          : `${basePriceNum.toFixed(2)} × 1 = ${customPrice}`;
        
        // Create the description for desp field
        const separationType = colorSeparation === "full" ? "Full Color Separation" : "Spot Color Separation";
        const despValue = `${separationType}: ${calculationStr}`;
        
        itemToAdd.calculation_note = despValue;
        itemToAdd.desp = despValue; // Add the desp field with the CTP details
      }

      addItem(itemToAdd);
      handleClosePriceDialog();
    }
  };

  const handleEditItemPrice = (itemId, currentPrice, minSalePrice) => {
    setEditingItemId(itemId);
    setEditPrice(currentPrice.toString());
    setEditPriceError("");
  };

  const handleEditPriceChange = (value, minSalePrice) => {
    setEditPrice(value);
    const error = validatePrice(value, minSalePrice);
    setEditPriceError(error);
  };

  const handleSaveEditPrice = (itemId, minSalePrice) => {
    const error = validatePrice(editPrice, minSalePrice);
    if (error) {
      setEditPriceError(error);
      return;
    }
    if (editPrice && updateItemPrice) {
      updateItemPrice(itemId, Number.parseFloat(editPrice));
      setSnackbarMessage("Price updated successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    }
    setEditingItemId(null);
    setEditPrice("");
    setEditPriceError("");
  };

  const handleCancelEditPrice = () => {
    setEditingItemId(null);
    setEditPrice("");
    setEditPriceError("");
  };

  const fetchInitialData = async () => {
    try {
      setLoading((prev) => ({ ...prev, products: true, grades: true }));
      const [productsRes, categoriesRes, gradesRes] = await Promise.all([
         getBarInventoryByBranch(),
        getCategories(),
        getCustomerGrades(),
      ]);

      const productsWithCategoryName = productsRes.data.map(p => {
        const category = categoriesRes.data.find(c => c.category_id === p.productCategory);
        return { ...p, category: category ? category.name : 'Unknown' };
      });

      setAllProducts(productsWithCategoryName);
      setProducts(useGradePricing ? [] : productsWithCategoryName);
      setCategories(categoriesRes.data);
      setCustomerGrades(gradesRes.data);
      if (gradesRes.data.length > 0) {
        setNewCustomer((prev) => ({
          ...prev,
          grade: gradesRes.data[0].grade_id,
        }));
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
      setSnackbarMessage("Failed to load initial data.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading((prev) => ({ ...prev, products: false, grades: false }));
    }
  };

  const fetchReceptionists = async () => {
    try {
      setLoadingReceptionists(true);
      const response = await getStaffList_saleapp();

      console.log({response});
      if (response.status === true) {
        // Filter for receptionists or staff with appropriate role
        // Adjust the filtering logic based on your actual API response structure
        const staffList = response.data || [];
        const receptionistList = staffList.filter(staff => 
          staff.roleID === '33' 
           
        );
        setReceptionists(receptionistList);
      } else {
        setSnackbarMessage("Failed to load receptionists.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error fetching receptionists:", error);
      setSnackbarMessage("Failed to load receptionists.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoadingReceptionists(false);
    }
  };

  const fetchCustomers = async (searchTerm) => {
     if (searchTerm.length < 3) {
      setSearchedCustomers([]);
      return;
    }
    try {
      setLoading((prev) => ({ ...prev, customers: true }));
      const response = await searchCustomers(searchTerm);
      setSearchedCustomers(response.data);
    } catch (error) {
      console.error("Error searching customers:", error);
      setSnackbarMessage("Failed to search customers.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading((prev) => ({ ...prev, customers: false }));
    }
  };

  useEffect(() => {
    fetchInitialData();
    fetchReceptionists(); // Fetch receptionists on component mount
  }, []);

  useEffect(() => {
    if (useGradePricing) {
      if (!selectedCustomer || !selectedCustomer.customer_grade) {
        setProducts([]);
        return;
      }
      const gradeId = selectedCustomer.customer_grade;
      const filtered = allProducts.filter(
        (product) =>
          product.grade_ids?.includes(gradeId) ||
          product.grade_id === gradeId ||
          !product.grade_id
      );
      setProducts(filtered);
    } else {
      setProducts(allProducts);
    }
  }, [selectedCustomer, allProducts, useGradePricing]);

  useEffect(() => {
      if (customerSearchQuery.trim() === '') {
        setSearchedCustomers([]);
        return;
      }
      const timerId = setTimeout(() => {
        fetchCustomers(customerSearchQuery);
      }, 500);
      return () => clearTimeout(timerId);
    }, [customerSearchQuery]);

  const onHandleCreateOrder = async () => {
    if (!selectedReceptionist) {
      setSnackbarMessage("Please select a receptionist before processing order.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    if (!selectedCustomer) {
      setSnackbarMessage("Please select a customer before processing order.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setProcessingOrder(true);
    
    const itemsWithDescription = items.map(item => {
      const newItem = { ...item };
      
      // For flex printing items, use length by breadth for description
      if (isFlexPrintingCategory(item.category) && item.length && item.breadth) {
        newItem.description = `${item.length} by ${item.breadth}`;
      }
      
      // For CTP items, use the desp field as description
      if (isCTPCategory(item.category) && item.desp) {
        newItem.description = item.desp;
      }
      
      // Add transaction_category to each item
      newItem.transaction_category = selectedTransactionCategory;
      return newItem;
    });

    const saleData = {
      customer_id: selectedCustomer?.user_id || null,
      items: itemsWithDescription,
      totalPrice: totalAmount,
      paymentType: "cash",
      amountPaid: totalAmount,
      changeGiven: 0,
      pricing_mode: useGradePricing ? "grade" : "manual",
      transaction_category: selectedTransactionCategory, // Add category to transaction
      receptionist_id: selectedReceptionist?.user_id || null,
      receptionist_name: `${selectedReceptionist?.firstName} ${selectedReceptionist?.lastName}`,
    };
    
    console.log("saleData to backend:", saleData);
    // return;

    try {
      const res = await createCustomerOrder(saleData);

      console.log(res);
      if (res.status === true) {
        setSnackbarMessage("Order created successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setLastOrderCustomer(selectedCustomer);
        setShowProcessPaymentDialog(true);
        clearCart();
        fetchInitialData();
        setSelectedCustomer(null);
        setSelectedTransactionCategory(""); // Reset category after order
      } else {
        setSnackbarMessage("Failed to create order." + (res.message || ""));
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }
    } catch (error) {
      console.error("Error creating order:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Failed to create order. Please try again.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setProcessingOrder(false);
    }
  };

  const handleAddCustomer = async () => {
    if (!selectedReceptionist) {
      setSnackbarMessage("Please select a receptionist before adding a customer.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setLoadingx(true);
    try {
      const response = await createCustomer(newCustomer);
      setSelectedCustomer(response.data);
      setShowCustomerDialog(false);
      setNewCustomer({
        firstName: "",
        middleName: "",
        lastName: "",
        phone: "",
        email: "",
        grade: customerGrades[0]?.grade_id || "",
      });
      setCustomerSearchQuery("");
      setSnackbarMessage("Customer added successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setLoadingx(false);
    } catch (error) {
      setLoadingx(false);
      console.error("Error creating customer:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Failed to add customer. Please check inputs.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const cartItemRemoveHandler = (id) => {
    removeItem(id);
  };

  const cartItemAddHandler = (item) => {
    // Check if we can add more of this item
    const availableQty = getRemainingQuantity(item.product_id);
    if (availableQty <= 0) {
      setSnackbarMessage(`Cannot add more ${item.product_name}. Only ${getAvailableQuantity(item.product_id)} available in stock.`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
    
    addItem({ ...item, quantity: 1 });
  };

  const getProductPrice = (product) => {
    if (useGradePricing && selectedCustomer) {
      return product.price - selectedCustomer?.grade_value * product?.price;
    }
    return product?.price;
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };
  const [selectedGrade, setSelectedGrade] = useState("");

  const onChange = (event) => {
    const percentage = Number(event.target.value);
    if (selectedProduct?.price && percentage) {
      const newPrice = Number(selectedProduct.price) * (1 - percentage);
      setCustomPrice(newPrice.toFixed(2));
    }
  };

  const filteredGrades = customerGrades?.filter(
    (grade) => grade.product_id === selectProduct?.product_id
  );

  const [loadingx, setLoadingx] = useState(false);

  return (
    <IonPage className="pushDown">
      <IonContent>
        <Box
          sx={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            bgcolor: "#f5f7fa",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              p: 2,
              bgcolor: "#667eea",
              color: "white",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: 700 }}>
                Sales Posting
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {selectedReceptionist && (
                  <Chip
                    label={`Receptionist: ${getFullName(selectedReceptionist)}`}
                    onDelete={() => {
                      setSelectedReceptionist(null);
                      setSelectedCustomer(null);
                      setSelectedTransactionCategory(""); // Clear category when clearing customer
                      clearCart();
                    }}
                    deleteIcon={<Close />}
                    avatar={
                      <Avatar sx={{ bgcolor: "white", color: "#667eea" }}>
                        <People />
                      </Avatar>
                    }
                    sx={{
                      bgcolor: "rgba(255,255,255,0.2)",
                      color: "white",
                      "& .MuiChip-deleteIcon": { color: "white" },
                    }}
                  />
                )}
                {selectedCustomer ? (
                  <Chip
                    label={`Customer: ${selectedCustomer.firstName} ${selectedCustomer.lastName} (${selectedCustomer.phone})`}
                    onDelete={() => {
                      setSelectedCustomer(null);
                      setSelectedTransactionCategory(""); // Clear category when clearing customer
                      clearCart();
                    }}
                    deleteIcon={<Close />}
                    avatar={
                      <Avatar sx={{ bgcolor: "white", color: "#667eea" }}>
                        <Person />
                      </Avatar>
                    }
                    sx={{
                      bgcolor: "rgba(255,255,255,0.2)",
                      color: "white",
                      "& .MuiChip-deleteIcon": { color: "white" },
                    }}
                  />
                ) : (
                  <Button
                    variant="contained"
                    startIcon={<PersonAdd />}
                    onClick={() => setShowCustomerDialog(true)}
                    sx={{
                      bgcolor: "white",
                      color: "#667eea",
                      "&:hover": { bgcolor: "#f0f0f0" },
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Select Customer
                  </Button>
                )}
              </Box>
            </Box>
          </Box>

          {/* Main Content */}
          <Box sx={{ flex: 1, display: "flex", overflow: "hidden" }}>
            {/* Product Selection Panel */}
            <Box
              sx={{
                width: { xs: "100%", md: "70%" },
                p: 2,
                overflowY: "auto",
                borderRight: { md: "1px solid #e0e0e0" },
              }}
            >
              {/* Show instruction message when receptionist or customer is not selected */}
              {(!selectedReceptionist || !selectedCustomer) ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    textAlign: "center",
                    py: 4,
                  }}
                >
                  <Person
                    sx={{ fontSize: 64, color: "text.disabled", mb: 2 }}
                  />
                  <Typography
                    variant="h6"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                  >
                    {!selectedReceptionist 
                      ? "Please select a receptionist and customer first" 
                      : "Please select a customer first"}
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<PersonAdd />}
                    onClick={() => setShowCustomerDialog(true)}
                    sx={{
                      mt: 2,
                      bgcolor: "#667eea",
                      color: "white",
                      "&:hover": { bgcolor: "#5a6fd8" },
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Select Customer
                  </Button>
                </Box>
              ) : useGradePricing && !selectedCustomer ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    textAlign: "center",
                    py: 4,
                  }}
                >
                  <Person
                    sx={{ fontSize: 64, color: "text.disabled", mb: 2 }}
                  />
                  <Typography
                    variant="h6"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                  >
                    Please select a customer to view grade-based products
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<PersonAdd />}
                    onClick={() => setShowCustomerDialog(true)}
                    sx={{
                      mt: 2,
                      bgcolor: "#667eea",
                      color: "white",
                      "&:hover": { bgcolor: "#5a6fd8" },
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Select Customer
                  </Button>
                </Box>
              ) : (
                <>
                  {/* Search and Categories */}
                  <Box
                    sx={{
                      mb: 2,
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <TextField
                      fullWidth
                      placeholder="Search products..."
                      variant="outlined"
                      size="small"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ flexGrow: 1 }}
                    />
                    {!useGradePricing && (
                      <Chip
                        icon={<PaymentOutlined />}
                        label="Manual Pricing"
                        color="secondary"
                        variant="outlined"
                      />
                    )}
                  </Box>
                  <Tabs
                    value={selectedCategory}
                    onChange={(e, newValue) => {
                      setSelectedCategory(newValue);
                    }}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
                  >
                    <Tab label="All" value={null} />
                    {categories?.map((category, i) => (
                      <Tab
                        key={i}
                        label={category.name}
                        value={category.category_id}
                      />
                    ))}
                  </Tabs>
                  {/* Product Grid */}
                  {loading.products ? (
                    <Grid container spacing={2}>
                      {Array.from({ length: 8 }).map((_, index) => (
                        <Grid item xs={6} sm={4} md={3} key={index}>
                          <StyledProductCard
                            sx={{
                              height: 180,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <CircularProgress size={40} sx={{ mb: 2 }} />
                            <Typography variant="subtitle1">
                              Loading...
                            </Typography>
                          </StyledProductCard>
                        </Grid>
                      ))}
                    </Grid>
                  ) : filteredProducts?.length > 0 ? (
                    <Grid container spacing={2}>
                      {filteredProducts.map((product, i) => (
                        <Grid item xs={6} sm={4} md={3} key={i}>
                          <StyledProductCard
                            onClick={() => {
                              if (product.qty > 0 && selectedReceptionist && selectedCustomer) {
                                handleAddToCart(product);
                              }
                            }}
                            sx={{
                              opacity: (!selectedReceptionist || !selectedCustomer || product.qty === 0) ? 0.5 : 1,
                              cursor: (!selectedReceptionist || !selectedCustomer || product.qty === 0) ? 'not-allowed' : 'pointer',
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <Avatar
                                src={
                                  product.img_src ||
                                  "/placeholder.svg?height=80&width=80&query=product"
                                }
                                alt={product.name}
                                sx={{ width: 80, height: 80, mb: 1 }}
                              />
                              <Typography
                                variant="subtitle1"
                                align="center"
                                sx={{ fontWeight: 600 }}
                              >
                                {product.name}
                              
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {useGradePricing
                                  ? formatCurrencyN(getProductPrice(product))
                                  : `Base: ${formatCurrencyN(product.price)}`}
                              </Typography>
                              {!useGradePricing && product.minSalePrice && (
                                <Typography
                                  variant="caption"
                                  color="warning.main"
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <Warning fontSize="small" />
                                  Min:{" "}
                                  {formatCurrencyN(
                                    Number(product.minSalePrice)
                                  )}
                                </Typography>
                              )}
                              {!useGradePricing && (
                                <Chip
                                  label={
                                    product.qty < 1
                                      ? "Out of Stock"
                                      : `Qty: ${product.qty}`
                                  }
                                  size="small"
                                  color={product.qty < 1 ? "error" : "secondary"}
                                  sx={{ mt: 1 }}
                                />
                              )}
                            </Box>
                          </StyledProductCard>
                        </Grid>
                      ))}
                    </Grid>
                  ) : (
                    <Grid item xs={12} sx={{ textAlign: "center", p: 4 }}>
                    </Grid>
                  )}
                </>
              )}
            </Box>

            {/* Cart Panel */}
            <Box
              sx={{
                width: { xs: "100%", md: "30%" },
                display: "flex",
                flexDirection: "column",
                bgcolor: "background.paper",
                boxShadow: { xs: "0 -4px 12px rgba(0,0,0,0.1)", md: "none" },
              }}
            >
              <Box
                sx={{
                  p: 2,
                  bgcolor: "background.paper",
                  borderBottom: "1px solid #e0e0e0",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  <Badge
                    badgeContent={items.length}
                    color="primary"
                    sx={{ mr: 1 }}
                  >
                    <ShoppingCart />
                  </Badge>
                  Current Order
                </Typography>
                <Button
                  size="small"
                  color="error"
                  startIcon={<ClearAll />}
                  onClick={clearCart}
                  disabled={items.length === 0}
                  sx={{ borderRadius: 2, textTransform: "none" }}
                >
                  Clear
                </Button>
              </Box>
              <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
                {items.length === 0 ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      textAlign: "center",
                      py: 4,
                    }}
                  >
                    <ShoppingCart
                      sx={{ fontSize: 64, color: "text.disabled", mb: 1 }}
                    />
                    <Typography variant="body1" color="text.secondary">
                      Your cart is empty
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {!selectedReceptionist || !selectedCustomer 
                        ? "Select receptionist and customer to add products" 
                        : "Select products to add to order"}
                    </Typography>
                  </Box>
                ) : (
                  <List dense>
                    {items.map((item, i) => (
                      <ListItem
                        key={i}
                        sx={{
                          py: 1,
                          flexDirection: "column",
                          alignItems: "stretch",
                          borderBottom: "1px dashed #eee",
                          "&:last-child": { borderBottom: "none" },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <Avatar
                            src={
                              item?.image ||
                              "/placeholder.svg?height=40&width=40&query=product"
                            }
                            alt={item.product_name}
                            sx={{ width: 40, height: 40, mr: 2 }}
                          />
                          <Box sx={{ flex: 1 }}>
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: 600 }}
                            >
                              {item.product_name}
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              {editingItemId === item.product_id ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                    }}
                                  >
                                    <TextField
                                      size="small"
                                      value={editPrice}
                                      onChange={(e) =>
                                        handleEditPriceChange(
                                          e.target.value,
                                          item.min_sale_price
                                        )
                                      }
                                      type="number"
                                      sx={{ width: 120 }}
                                      error={!!editPriceError}
                                      InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            ₦
                                          </InputAdornment>
                                        ),
                                      }}
                                      placeholder="Enter new price"
                                    />
                                    <Tooltip title="Accept Price">
                                      <IconButton
                                        size="small"
                                        color="success"
                                        onClick={() =>
                                          handleSaveEditPrice(
                                            item.product_id,
                                            item.min_sale_price
                                          )
                                        }
                                        disabled={!!editPriceError}
                                      >
                                        <Check fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Cancel">
                                      <IconButton
                                        size="small"
                                        color="error"
                                        onClick={handleCancelEditPrice}
                                      >
                                        <Cancel fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                  {editPriceError && (
                                    <Typography
                                      variant="caption"
                                      color="error"
                                      sx={{ fontSize: "0.7rem" }}
                                    >
                                      {editPriceError}
                                    </Typography>
                                  )}
                                  {item.min_sale_price && (
                                    <Typography
                                      variant="caption"
                                      color="warning.main"
                                      sx={{ fontSize: "0.7rem" }}
                                    >
                                      Minimum: {formatCurrencyN(item.min_sale_price)}
                                    </Typography>
                                  )}
                                </Box>
                              ) : (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 600 }}
                                  >
                                    {formatCurrencyN(item.price)}
                                  </Typography>
                                  <Tooltip title="Edit price">
                                    <IconButton
                                      size="small"
                                      onClick={() =>
                                        handleEditItemPrice(
                                          item.product_id,
                                          item.price,
                                          item.min_sale_price
                                        )
                                      }
                                    >
                                      <Edit fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                              )}
                            </Box>
                            {item.custom_price && (
                              <Chip
                                label="Custom Price"
                                size="small"
                                color="secondary"
                                sx={{ mt: 0.5 }}
                              />
                            )}
                            {item.calculation_note && (
                              <Typography variant="caption" color="text.secondary">
                                {item.calculation_note}
                              </Typography>
                            )}
                            {item.desp && (
                              <Typography variant="caption" color="primary" sx={{ display: 'block', mt: 0.5 }}>
                                <strong>CTP Details:</strong> {item.desp}
                              </Typography>
                            )}
                          </Box>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <IonButton
                              fill="clear"
                              size="small"
                              onClick={() =>
                                cartItemRemoveHandler(item.product_id)
                              }
                            >
                              <IonIcon slot="icon-only" icon={removeOutline} />
                            </IonButton>
                            <IonText>{item.quantity}</IonText>
                            <IonButton
                              fill="clear"
                              size="small"
                              onClick={() => cartItemAddHandler(item)}
                              disabled={getRemainingQuantity(item.product_id) <= 0}
                            >
                              <IonIcon slot="icon-only" icon={addIcon} />
                            </IonButton>
                          </Box>
                        </Box>
                        {/* Show available quantity warning */}
                        {getRemainingQuantity(item.product_id) <= 0 && (
                          <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                            Maximum quantity reached
                          </Typography>
                        )}
                      </ListItem>
                    ))}
                  </List>
                )}
              </Box>
              {/* Order Summary */}
              <Box
                sx={{
                  p: 2,
                  borderTop: "1px solid #e0e0e0",
                  bgcolor: "background.paper",
                  boxShadow: "0 -2px 8px rgba(0,0,0,0.05)",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Total:
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 700, color: "#667eea" }}
                  >
                    {formatCurrencyN(totalAmount)}
                  </Typography>
                </Box>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  onClick={onHandleCreateOrder}
                  startIcon={
                    processingOrder ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <Receipt />
                    )
                  }
                  sx={{
                    mt: 2,
                    bgcolor: "#667eea",
                    color: "white",
                    "&:hover": { bgcolor: "#5a6fd8" },
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 600,
                    py: 1.5,
                  }}
                  disabled={
                    items.length === 0 ||
                    processingOrder ||
                    selectedCustomer === null ||
                    selectedReceptionist === null
                  }
                >
                  {processingOrder ? "Processing..." : "Process Payment"}
                </Button>
              </Box>
            </Box>
          </Box>

          {/* Custom Price Dialog */}
          <Dialog
            open={showPriceDialog}
            onClose={handleClosePriceDialog}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle sx={{ pb: 1 }}>
              Set Custom Price
              <IconButton
                sx={{ position: "absolute", right: 8, top: 8 }}
                onClick={handleClosePriceDialog}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              {selectedProduct && (
                <Box sx={{ textAlign: "center", mb: 3 }}>
                  <Avatar
                    src={
                      selectedProduct.img_src ||
                      "/placeholder.svg?height=80&width=80&query=product"
                    }
                    alt={selectedProduct.name}
                    sx={{ width: 80, height: 80, mx: "auto", mb: 2 }}
                  />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {selectedProduct.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                   Base Price: {formatCurrencyN(selectedProduct.price)}
                  </Typography>
                  {selectedProduct.minSalePrice && (
                    <Alert severity="warning" sx={{ mt: 2, mb: 2 }}>
                      <Typography variant="body2">
                        <strong>
                          Minimum Sale Price:{" "}
                          {formatCurrencyN(selectedProduct.minSalePrice)}
                        </strong>
                      </Typography>
                      <Typography variant="caption">
                        You cannot sell this product below the minimum price.
                      </Typography>
                    </Alert>
                  )}
                  <Alert severity="info" sx={{ mt: 1 }}>
                    <Typography variant="body2">
                      Available Quantity: {getRemainingQuantity(selectedProduct.product_id)}
                    </Typography>
                  </Alert>
                </Box>
              )}

            {/* Flex Printing Calculation Section */}
            {selectedProduct && isFlexPrintingCategory(selectedProduct.category) && (
              <Box sx={{ mt: 2, mb: 2, p: 2, border: '1px dashed grey', borderRadius: 2 }}>
                <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
                  Flex Printing Calculation
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Length"
                      type="number"
                      value={length}
                      onChange={(e) => setLength(e.target.value)}
                      helperText="In meters"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Breadth"
                      type="number"
                      value={breadth}
                      onChange={(e) => setBreadth(e.target.value)}
                      helperText="In meters"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Special Price (per sq. meter)"
                      type="number"
                      value={specialPrice}
                      onChange={(e) => setSpecialPrice(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">₦</InputAdornment>
                        ),
                      }}
                      helperText={`Default: ${formatCurrencyN(selectedProduct.sellingPrice || selectedProduct.price || 0)}`}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Alert severity="info" sx={{ mt: 1 }}>
                      <Typography variant="body2">
                        Calculation: {length || 0} × {breadth || 0} × {specialPrice || 0} = {formatCurrencyN(customPrice || 0)}
                      </Typography>
                    </Alert>
                  </Grid>
                </Grid>
              </Box>
            )}

            {/* CTP Calculation Section */}
            {selectedProduct && isCTPCategory(selectedProduct.category) && (
              <Box sx={{ mt: 2, mb: 2, p: 2, border: '1px dashed grey', borderRadius: 2 }}>
                <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
                  CTP Color Separation
                </Typography>
                <FormControl component="fieldset" fullWidth>
                  <FormLabel component="legend">Select Color Separation Type:</FormLabel>
                  <RadioGroup
                    value={colorSeparation}
                    onChange={(e) => setColorSeparation(e.target.value)}
                  >
                    <Box sx={{ mb: 2 }}>
                      <FormControlLabel
                        value="spot"
                        control={<Radio />}
                        label={
                          <Box>
                            <Typography variant="body1">Spot Color Separation</Typography>
                            <Typography variant="caption" color="text.secondary">
                              Price = Base Price × 1
                            </Typography>
                          </Box>
                        }
                      />
                      <Box sx={{ ml: 4, mt: 0.5 }}>
                        <Typography variant="caption" color="text.secondary">
                          Single color printing, ideal for simple designs
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <FormControlLabel
                        value="full"
                        control={<Radio />}
                        label={
                          <Box>
                            <Typography variant="body1">Full Color Separation</Typography>
                            <Typography variant="caption" color="text.secondary">
                              Price = (Base Price - 50) × 4
                            </Typography>
                          </Box>
                        }
                      />
                      <Box sx={{ ml: 4, mt: 0.5 }}>
                        <Typography variant="caption" color="text.secondary">
                          CMYK four-color printing, ideal for complex multi-color designs
                        </Typography>
                      </Box>
                    </Box>
                  </RadioGroup>
                </FormControl>
                
                <TextField
                  fullWidth
                  label="Base Price"
                  type="number"
                  value={ctpBasePrice}
                  onChange={(e) => setCtpBasePrice(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">₦</InputAdornment>
                    ),
                  }}
                  helperText={`Default: ${formatCurrencyN(selectedProduct.price || 0)}`}
                  sx={{ mt: 2 }}
                />
                
                <Alert severity="info" sx={{ mt: 2 }}>
                  <Typography variant="body2">
                    Calculation: {
                      colorSeparation === "full" 
                        ? `(${ctpBasePrice || 0} - 50) × 4 = ${formatCurrencyN(customPrice || 0)}`
                        : `${ctpBasePrice || 0} × 1 = ${formatCurrencyN(customPrice || 0)}`
                    }
                  </Typography>
                </Alert>
              </Box>
            )}

              <TextField
                fullWidth
                label="Custom Price"
                type="number"
                value={customPrice}
                onChange={(e) => handleCustomPriceChange(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">₦</InputAdornment>
                  ),
                }}
                error={!!priceError}
                helperText={
                  priceError ||
                  (selectedProduct?.minSalePrice
                    ? `Minimum: ${formatCurrencyN(
                        selectedProduct.minSalePrice
                      )}`
                    : "")
                }
                autoFocus
                disabled={selectedProduct && (isFlexPrintingCategory(selectedProduct.category) || isCTPCategory(selectedProduct.category))}
              />

              <TextField
                fullWidth
                label="Quantity"
                type="number"
                value={quantity}
                onChange={(e) => handleQuantityChange(e.target.value)}
                InputProps={{
                  inputProps: { 
                    min: 1, 
                    max: getRemainingQuantity(selectedProduct?.product_id) 
                  },
                }}
                helperText={`Maximum: ${getRemainingQuantity(selectedProduct?.product_id)} available`}
                sx={{ mt: 2 }}
              />

              <TextField
                fullWidth
                label="Total Amount"
                type="number"
                value={totalAmountInput}
                onChange={(e) => handleTotalAmountChange(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">₦</InputAdornment>
                  ),
                }}
                sx={{ mt: 2 }}
              />
            </DialogContent>
            <DialogActions sx={{ p: 3 }}>
              <Button
                onClick={handleClosePriceDialog}
                sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleAddWithCustomPrice}
                disabled={
                  !customPrice ||
                  Number.parseFloat(customPrice) <= 0 ||
                  !!priceError ||
                  (selectedProduct && Number.parseFloat(customPrice) < Number(selectedProduct.minSalePrice)) ||
                  quantity > getRemainingQuantity(selectedProduct?.product_id)
                }
                startIcon={<Add />}
                sx={{
                  bgcolor: "#667eea",
                  color: "white",
                  "&:hover": { bgcolor: "#5a6fd8" },
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Add to Cart
              </Button>
            </DialogActions>
          </Dialog>

          {/* Customer Selection Dialog */}
          <Dialog
            open={showCustomerDialog}
            onClose={() => setShowCustomerDialog(false)}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle sx={{ pb: 1 }}>
              {selectedCustomer ? "Change Customer" : "Select Customer"}
              <IconButton
                sx={{ position: "absolute", right: 8, top: 8 }}
                onClick={() => setShowCustomerDialog(false)}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              {/* Product Category Selection - ADDED THIS SECTION */}
              <Box sx={{ mb: 3 }}>
                <FormControl fullWidth size="small">
                  <InputLabel id="transaction-category-label">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Category fontSize="small" />
                      Select Product Category (Optional)
                    </Box>
                  </InputLabel>
                  <Select
                    labelId="transaction-category-label"
                    value={selectedTransactionCategory}
                    label="Select Product Category (Optional)"
                    onChange={(e) => setSelectedTransactionCategory(e.target.value)}
                  >
                    <MenuItem value="">
                      <em>Select Product Category (Optional)</em>
                    </MenuItem>
                    {categories?.map((category) => (
                      <MenuItem key={category.category_id} value={category.category_id}>
                        {category.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                  This category will be included in the transaction details sent to the endpoint.
                </Typography>
              </Box>

              <Divider sx={{ mb: 2 }} />

              {/* Receptionist Selection Dropdown - JUST BELOW THE CATEGORY SELECTION */}
              <Box sx={{ mb: 3 }}>
                <FormControl fullWidth>
                  <InputLabel>Select Receptionist</InputLabel>
                  <Select
                    value={selectedReceptionist?.user_id || ""}
                    label="Select Receptionist"
                    onChange={(e) => {
                      const receptionistId = e.target.value;
                      const selected = receptionists.find(r => r.user_id === receptionistId);
                      setSelectedReceptionist(selected || null);
                    }}
                    disabled={loadingReceptionists}
                  >
                    <MenuItem value="">
                      <em>Select a receptionist</em>
                    </MenuItem>
                    {receptionists.map((receptionist) => (
                      <MenuItem key={receptionist.user_id} value={receptionist.user_id}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Avatar sx={{ width: 32, height: 32, mr: 2, bgcolor: '#667eea' }}>
                            <People fontSize="small" />
                          </Avatar>
                          <Box>
                            <Typography variant="body1">
                              {getFullName(receptionist)}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              Receptionist
                            </Typography>
                          </Box>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {loadingReceptionists && (
                  <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                    <CircularProgress size={20} sx={{ mr: 1 }} />
                    <Typography variant="caption">Loading receptionists...</Typography>
                  </Box>
                )}
              </Box>

              <Divider sx={{ mb: 2 }} />

              {/* Customer Search Section */}
              <Box sx={{ mb: 2 }}>
                <TextField
                  fullWidth
                  placeholder="Search customers by name or phone..."
                  variant="outlined"
                  size="small"
                  value={customerSearchQuery}
                  onChange={(e) => setCustomerSearchQuery(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              {loading.customers ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                  <CircularProgress />
                </Box>
              ) : searchedCustomers.length > 0 ? (
                <List sx={{ maxHeight: 200, overflow: 'auto' }}>
                  {searchedCustomers?.map(customer => (
                    <ListItem
                      button
                      key={customer.user_id}
                      onClick={() => {
                        if (!selectedReceptionist) {
                          setSnackbarMessage("Please select a receptionist first.");
                          setSnackbarSeverity("error");
                          setSnackbarOpen(true);
                          return;
                        }
                        console.log("Selected customer:", customer);
                        setSelectedCustomer(customer);
                        setShowCustomerDialog(false);
                        setCustomerSearchQuery('');
                        clearCart();
                      }}
                      selected={selectedCustomer?.id === customer.id}
                      disabled={!selectedReceptionist}
                    >
                      <ListItemText  
                        primary={`${customer.firstName} ${customer.lastName}`}
                        secondary={`${customer.phone} `}
                      />
                    </ListItem>
                  ))}
                </List>
              ) : customerSearchQuery ? (
                <Box sx={{ p: 2, textAlign: 'center' }}>
                  <Typography>No customers found matching "{customerSearchQuery}"</Typography>
                </Box>
              ) : (
                <Box sx={{ p: 2, textAlign: 'center' }}>
                  <Typography>Enter a name or phone number to search for customers</Typography>
                </Box>
              )}
              
              <Divider sx={{ my: 2 }} />
              
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Add New Customer
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <TextField
                    fullWidth
                    label="Full Name(s)"
                    value={newCustomer.firstName}
                    onChange={(e) =>
                      setNewCustomer({
                        ...newCustomer,
                        firstName: e.target.value,
                      })
                    }
                    required
                    disabled={!selectedReceptionist}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Phone Number"
                    value={newCustomer.phone}
                    onChange={(e) =>
                      setNewCustomer({ ...newCustomer, phone: e.target.value })
                    }
                    required
                    disabled={!selectedReceptionist}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Email"
                    value={newCustomer.email}
                    onChange={(e) =>
                      setNewCustomer({ ...newCustomer, email: e.target.value })
                    }
                    disabled={!selectedReceptionist}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 3 }}>
              <Button
                onClick={() => setShowCustomerDialog(false)}
                sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleAddCustomer}
                disabled={
                  loadingx || !newCustomer.firstName || !newCustomer.phone || !selectedReceptionist
                }
                startIcon={!loadingx && <Add />}
                sx={{
                  bgcolor: "#667eea",
                  color: "white",
                  "&:hover": { bgcolor: "#5a6fd8" },
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                {loadingx ? (
                  <Box display="flex" alignItems="center" gap={1}>
                    <CircularProgress size={20} color="inherit" />
                    <span>Adding...</span>
                  </Box>
                ) : (
                  "Add Customer"
                )}
              </Button>
            </DialogActions>
          </Dialog>
          
          <Dialog open={showProcessPaymentDialog} onClose={() => setShowProcessPaymentDialog(false)}>
            <DialogTitle>Process Payment</DialogTitle>
            <DialogContent>
                <Typography>Do you want to process payment for this customer?</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setShowProcessPaymentDialog(false)}>No</Button>
                <Button 
                    onClick={() => {
                        history.push(`/folder/raise-receipt/AddReceipt`, { 
                          customer: lastOrderCustomer,
                          transaction_category: selectedTransactionCategory // Pass category to receipt
                        });
                        setShowProcessPaymentDialog(false);
                    }}
                    startIcon={<ArrowForward />}
                >
                    Yes, Proceed
                </Button>
            </DialogActions>
          </Dialog>

          <Snackbar
            open={snackbarOpen}
            autoHideDuration={6000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert
              onClose={(event) => handleSnackbarClose(event, undefined)}
              severity={snackbarSeverity}
              sx={{ width: "100%" }}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </Box>
      </IonContent>
    </IonPage>
  );
};

export default SalesPOSPage;